import { Grid } from '@material-ui/core';
import {
  Business,
  CheckBox,
  Description as DescriptionIcon,
  Euro as EuroIcon,
  EventAvailable,
  Language as LanguageIcon,
  Schedule,
  SchoolRounded as SchoolIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  VerifiedUser as VerifiedUserIcon,
  WatchLater as WatchLaterIcon,
  Home,
  DateRange,
  MenuBookRounded,
  Loop as LoopIcon,
} from '@material-ui/icons';
import { deleteFormation } from '@webapps/business';
import {
  Button,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import GradeIcon from 'components/Icons/GradeIcon';
import Modal from 'components/Modal';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import theme from 'pages/MyMap/theme';

import EditFormation from './EditFormation';
import HourglassHalf from 'components/Icons/HourglassHalf';
import DottedWire from 'components/Icons/DottedWire';
import ListChecked from 'components/Icons/ListChecked';

const {
  colors: { background },
} = theme;

const DetailsInformation = ({ info = {}, refetchAllFormation, close }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();
  const [stepModal, setStepModal] = useState(1);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteFormation,
  } = useMutation(deleteFormation);

  const [editModal, setEditModal] = useState(false);

  const handleOpenEditModal = () => {
    setEditModal(true);
  };

  const handleCloseEditModal = () => {
    setEditModal(false);
  };

  const handleDeleteFormation = async (id) => {
    await mutateDeleteFormation({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetchAllFormation();
      close();
    }
  }, [isSuccessDelete]);

  return (
    <div className={classes.container}>
      <div className={cx(classes.title, global.title)}><p style={{ margin: 0 }}>Informations pratiques :</p></div>
      <div className={classes.infoPratique}>
        <Grid container spacing={3}>
          <Grid item >
            <div className={cx(global.infoText, classes.info)}>
              <SchoolIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="levelDiplome" /><span className={css({ fontWeight: 400 })}> : {info?.degree?.label}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <MenuBookRounded color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Domaine d'étude<span className={css({ fontWeight: 400 })}> : {info?.domain?.label}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <DescriptionIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="typeContrate" /><span className={css({ fontWeight: 400 })}> : {info?.trainingType?.label}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <EuroIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="fraisInscription" /><span className={css({ fontWeight: 400 })}> : {info?.programCost} €</span>
              </div>

            </div>
            <div className={cx(global.infoText, classes.info)}>
              <EuroIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="fraisScolarite" /><span className={css({ fontWeight: 400 })}> : {info?.registrationFees} €</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <HourglassHalf className={cx(global.infoIcon, classes.itemIcon)} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="dureeFormation" /><span className={css({ fontWeight: 400 })}> : {info?.duration} mois</span>
              </div>
            </div>
            {info?.rythmAlternance && (
              <div className={cx(global.infoText, classes.info)}>
                <LoopIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
                <div className={css({ fontWeight: 600 })}>
                  <FormattedMessage id="cycleAlternance" /><span className={css({ fontWeight: 400 })}> : {info?.rythmAlternance}</span>
                </div>
              </div>
            )}
            <div className={cx(global.infoText, classes.info)}>
              <DateRange color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Dépot candidature<span> : </span>
              </div>
              <div>
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={
                    new Date(info?.applicationStartDate?.split('T')[0] ?? false)
                  }
                  year="numeric"
                />{' '}
                au{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={
                    new Date(
                      info?.applicationClosingDate?.split('T')[0] ?? false
                    )
                  }
                  year="numeric"
                />
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <ListChecked color="#0060F9" className={global.infoIcon} size={18} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="conditionAdmission" /><span className={css({ fontWeight: 400 })}> : {info?.entryRequierement?.label}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              {/* <Gesture color="primary" /> */}
              <GradeIcon color="#0060F9" className={global.infoIcon} size={18} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="reconaissanceDiplome" /><span className={css({ fontWeight: 400 })}> : {info?.certifyingAuthority?.label === 'Etat'
                  ? 'Reconnu par l’état'
                  : 'Non reconnu par l’état'}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <Home color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Présence<span className={css({ fontWeight: 400 })}> : {info?.studyPlan?.label}</span>
              </div>
            </div>
            <div className={cx(global.infoText, classes.info)}>
              <LanguageIcon color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                <FormattedMessage id="langRequis" /><span className={css({ fontWeight: 400 })}> : {info?.workedLangage?.map(({ label }) => `${label} `)}</span>
              </div>
            </div>
            {/* <div className={cx(global.infoText, classes.info)}>
              <VerifiedUserIcon color="primary" />
              <div>
                <FormattedMessage id="profilVerif" /><span> : </span>
              </div>
              <div>
                {info?.onlyVerfiedProfile ? 'Oui' : 'Non'}
              </div>
            </div> */}
            <div className={cx(global.infoText, classes.info)}>
              <EventAvailable color="primary" className={[global.infoIcon, classes.itemIcon]} />
              <div className={css({ fontWeight: 600 })}>
                Prochaine rentrée<span className={css({ fontWeight: 400 })}> : <FormattedDate
                  day="numeric"
                  month="long"
                  value={info?.openingDate?.split('T')[0]}
                  year="numeric"
                /></span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.textContainer}>
        <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Description :</p></div>
        <div className={classes.textarea}>
          {info?.description ? (
            <div className={classes.modifyLink}>{parse(info?.description)}</div>
          ) : (
            <div>Pas de description</div>
          )}
        </div>
      </div>
      <div className={css({ display: 'flex', justifyContent: 'flex-start' })}>
        <Button
          className={classes.btn}
          color="primary"
          disableElevation
          onClick={handleOpenEditModal}
          variant="contained"
        >
          Modifier
        </Button>
        <Button
          style={{ backgroundColor: 'white', }}
          color="secondary"
          disabled={isLoadingDelete}
          disableElevation
          onClick={() => handleDeleteFormation(info?.id)}
          variant="outlined"
        >
          Supprimer
        </Button>
      </div>
      <Modal
        nbStep={5}
        onCancel={handleCloseEditModal}
        open={editModal}
        step={stepModal}
        subTitle="Gérez votre formation"
        title="Modifiez la formation"
      >
        <EditFormation
          formation={info}
          onChangeStepModal={setStepModal}
          onClose={handleCloseEditModal}
          refetchFormation={refetchAllFormation}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    background,
  },
  title: {
    borderTop: '1px solid #C0D9FF',
    marginTop: spacing(2.5),
    paddingTop: spacing(2.5),
    marginBottom: spacing(2.5),
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1)
    },
  },
  mobilePaddingBottom: {
    '@media (max-width:768px)': { paddingBottom: '0 !important' }
  },
  mobilePaddingTop: {
    '@media (max-width:768px)': { paddingTop: '0 !important' }
  },
  textContainer: {
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: spacing(2),
    display: 'flex',
    alignItems: 'center',
    color: '#152652',
  },
  infoPratique: {
    marginTop: spacing(1),
    marginBottom: spacing(2),
  },
  modifyLink: {
    color: '#152652',
    a: {
      textDecoration: 'none',
    },
  },
  itemIcon: {
    color: '#0060F9',
  },
  btn: {
    marginRight: spacing(1),
  }
});

DetailsInformation.propTypes = {
  info: PropTypes.object,
  refetchAllFormation: PropTypes.func,
  close: PropTypes.func,
};

export default DetailsInformation;
